export const LIGHT_USER_DATA_RAYMARCHING_PENUMBRA = 'raymarchingPenumbra';
